import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d25844f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "流通股份结构图")
], -1))
const _hoisted_3 = { class: "sdltgdchartslist" }
const _hoisted_4 = { style: {"padding-top":"30px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "十大流通股东结构图")
], -1))
const _hoisted_6 = { class: "sdltgdchartslist" }
const _hoisted_7 = { class: "ybtitle-tooltip" }
const _hoisted_8 = ["onMouseleave", "onMouseenter"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "该图展示了十大流通股东持股、其余流通股份、流通受限股份在总股本中的占比情况，持股比例计算公式为各股份数/总股本", -1))
const _hoisted_10 = { class: "sdgdlt" }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_Charts = _resolveComponent("Charts")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Drawer = _resolveComponent("Drawer")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.radiolist || []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createVNode(_component_a_radio_group, {
              value: _ctx.radiovalue,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.radiovalue) = $event)),
              "button-style": "solid",
              onChange: _ctx.changeradio
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.radiolist, (item, i) => {
                  return (_openBlock(), _createBlock(_component_a_radio_button, {
                    value: item,
                    key: 'sdltgdradio' + i
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value", "onChange"]),
            _createElementVNode("ul", null, [
              _createElementVNode("li", null, [
                _hoisted_2,
                _createVNode(_component_Charts, {
                  id: "ltgfjgt",
                  option: _ctx.option
                }, null, 8, ["option"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("ul", _hoisted_4, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list1, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'sdltgdlist1' + i
                      }, [
                        _createElementVNode("i", {
                          style: _normalizeStyle({'background-color': ['#0060FF', '#00D894', '#F6BD16'][i]})
                        }, null, 4),
                        _createElementVNode("span", null, _toDisplayString(item.title), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _createElementVNode("li", null, [
                _hoisted_5,
                _createVNode(_component_Charts, {
                  id: "sdltgfjgt",
                  option: _ctx.option2
                }, null, 8, ["option"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list2, (item, i) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: 'sdltgdlist2' + i
                      }, [
                        _createElementVNode("i", {
                          style: _normalizeStyle({'background-color': _ctx.color[i]})
                        }, null, 4),
                        _createVNode(_component_a_tooltip, {
                          placement: "topLeft",
                          visible: _ctx.overflow[item.index],
                          align: {
                offset: [0, 4],
                },
                          destroyTooltipOnHide: "",
                          mouseEnterDelay: 0.4,
                          getPopupContainer: _ctx.getPopupContainer
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_7, _toDisplayString(item.SHName), 1)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: "overflow",
                              onMouseleave: _withModifiers(($event: any) => (_ctx.hidetool(item, i)), ["stop"]),
                              onMouseenter: _withModifiers(($event: any) => (_ctx.isoverflow(item, $event)), ["stop"]),
                              href: "javascript:void(0)"
                            }, _toDisplayString(item.SHName ? item.SHName : '—'), 41, _hoisted_8)
                          ]),
                          _: 2
                        }, 1032, ["visible", "mouseEnterDelay", "getPopupContainer"])
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _hoisted_9
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Table, {
                data: _ctx.data,
                columns: _ctx.columns,
                bordered: true,
                onShowdrawer: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showdrawer(1, 10, $event))),
                pagination: false
              }, null, 8, ["data", "columns"]),
              _createVNode(_component_Drawer, {
                title: 'sdltgddrawer',
                currentshareholder: _ctx.currentshareholder,
                class: "light sdltgdwrap",
                width: 560,
                visible: _ctx.visible,
                mask: true,
                onClose: _ctx.onClose,
                getContainer: _ctx.getContainer,
                wrapClassName: 'sdgd',
                tableData: _ctx.data2,
                columns: _ctx.columns2,
                total2: _ctx.total2,
                option: _ctx.optiongd_detail,
                onChangesize: _ctx.changesize
              }, null, 8, ["currentshareholder", "visible", "onClose", "getContainer", "tableData", "columns", "total2", "option", "onChangesize"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_11, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}